import { render } from "./VendorList.vue?vue&type=template&id=b14cb81e&scoped=true"
import script from "./VendorList.vue?vue&type=script&lang=js"
export * from "./VendorList.vue?vue&type=script&lang=js"

import "./VendorList.vue?vue&type=style&index=0&id=b14cb81e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b14cb81e"]])

export default __exports__